<mat-card class="p-6 min-h-full">
  <mat-card-header class="mb-6">
    <mat-card-title class="text-2xl font-semibold">{{ title() }}</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <form class="grid gap-4" [formGroup]="companyForm" (ngSubmit)="submit()">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Name *</mat-label>
        <input matInput formControlName="name" placeholder="Enter company name" [readonly]="readOnly()" />
        @if (companyForm.controls.name.invalid && companyForm.controls.name.touched) {
          <mat-error>Name is required.</mat-error>
        }
      </mat-form-field>

      @if (!readOnly()) {
        <div class="flex justify-end pt-4">
          <button matButton="filled" type="submit" [disabled]="companyForm.invalid || busy()">
            @if (busy()) {
              <mat-spinner diameter="20" class="mr-2" />
            }
            {{ submitLabel() }}
          </button>
          @if (utils.isNull(initialValue()) === false) {
            <button
              matButton="filled"
              type="button"
              class="mom-danger ml-4"
              [disabled]="!canToggleActive() || companyIsBusy()"
              (click)="deactivateAction.emit('')">
              @if (companyIsBusy()) {
                <mat-spinner diameter="20" class="mr-2" />
              }
              @if (!companyIsBusy()) {
                {{ initialValue()?.isActive ? 'Deactivate' : 'Activate' }}
              }
            </button>
            }
        </div>
      }
    </form>
  </mat-card-content>
</mat-card>
